import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ListAgentProfitRanges from "../Components/Agent Profit Range/listAgentProfitRange";

const AgentProfitRangesRoutes = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
//   const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');
//   const hasPermission = canAdd || canEdit;
  return (
    <Routes>
      <Route path="/agent_profit_ranges" element={canAdd ? <ListAgentProfitRanges /> : <Navigate to="/dashboard" replace />}></Route>
    </Routes>
  );
};

export default AgentProfitRangesRoutes;
